export const DOCUMENT_CATEGORIES:{
    [key:string]: Array<string>
} = {
    "Minutes": [
        'Yearly Service Reviews',
        'Service Progress Meetings',
        // 'Phase-in Progress Meetings',
        'Negotiation Meetings',
    ],
    "Reports":[
        'Inventory of Delivery Items',
        'Inventory of Delivery Media Content',
        'Media Ingestion Reports',
        'FTP/Cloud Ingestion Reports',
        'Data Ingestion Reports',
        'Full Service Monitoring Reports',
        'Financial Progress Reports',
        'Service Monitoring Reports for internal ESA dissemination',
    ],
    "RetrievalForms":[
        'Retrievals Request Forms'
    ],
    "Deliveries":[
        'Milestone Deliveries'
    ],
    "MediaStatus":[
        'Media Status Reports',
        'Media Anomaly Notices'
    ]
}

export const get_categroy_group = (category:string) =>{
    for(let group in DOCUMENT_CATEGORIES){
        if(DOCUMENT_CATEGORIES[group].includes(category)){
            return group;
        }
    }
    return '';
}